module.exports = __webpack_public_path__ + "static/img/kaishu_benefit1.9bb1fb98.jpg";